<script>
import CallOptionsModal from '@components/modals/call-options-modal'
import { mapState } from 'vuex'
import GTM_CONSTANTS from '@constants/google-tag-manager'

const INLINE_STYLE = 'inline'

export default {
  name: 'CallSupport',
  components: { CallOptionsModal },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('widgets', {
      common: state => state.common,
      userData: state => state.common.user,
    }),
    isInlineStyle: function () {
      return (
        !!this.componentData.displayStyle &&
        this.componentData.displayStyle === INLINE_STYLE
      )
    },
    validateAdditionalMessage: function () {
      return this.isInlineStyle
        ? this.$t('WIDGETS.CALL_SUPPORT.THIS_IS_AN_ERROR')
        : ''
    },
    validateButtonMessage: function () {
      return this.isInlineStyle
        ? this.$t('WIDGETS.CALL_SUPPORT.SIMPLE_CALL_SUPPORT')
        : this.$t('WIDGETS.CALL_SUPPORT.TITLE')
    },
    showCallSupport() {
      if (this.userData.os === 'unknown') return false
      return (
        this.componentData.show &&
        this.componentData.phonenumber_pstn &&
        this.componentData.phonenumber_pstn !== ''
      )
    },
  },
  methods: {
    showModal: function () {
      const { user } = this.common
      this.$gtm.trackEvent({
        event: GTM_CONSTANTS.LOG_EVENT,
        noninteraction: 'CLICK_CALL_SUPPORT',
        payload: {},
        eventType: 'CLICK_CALL_SUPPORT',
        user,
      })
      this.$modal.show(
        CallOptionsModal,
        {
          callData: this.componentData,
          texts: {
            title: this.$t('WIDGETS.CALL_SUPPORT.HOW_CALL'),
            phoneTitle: this.$t('WIDGETS.CALL_SUPPORT.PHONE'),
            dataTitle: this.$t('WIDGETS.CALL_SUPPORT.DATA'),
          },
          query: this.common.query,
          router: this.$router,
          dispatchCallSelection: value => {
            this.$gtm.trackEvent({
              event: GTM_CONSTANTS.LOG_EVENT,
              noninteraction: 'SELECT_CALL_SUPPORT_TYPE',
              payload: value,
              eventType: 'SELECT_CALL_SUPPORT_TYPE',
              user: this.common.user,
            })
          },
          dispatchShowCallSelection: value => {
            this.$gtm.trackEvent({
              event: GTM_CONSTANTS.LOG_EVENT,
              noninteraction: 'VIEW_CALL_SUPPORT_SELECTION',
              payload: value,
              eventType: 'VIEW_CALL_SUPPORT_SELECTION',
              user: this.common.user,
            })
          },
        },
        {
          height: 'auto',
          width: '90%',
          scrollable: true,
        },
        {
          'before-close': event => {},
        }
      )
    },
  },
}
</script>

<template>
  <div
    v-if="showCallSupport"
    :class="$style.container">
    <span>{{ validateAdditionalMessage }}</span>
    <button
      :class="$style.container__button"
      @click="showModal()">{{ validateButtonMessage }}</button>
  </div>
</template>

<style scoped lang="scss" module>
@import '@design';

.container {
  padding: 0.5rem 0;
  margin: 0;
  font-size: 1.25rem;

  &__button {
    margin: 0.4rem 0 0.6rem 0;
    color: $rappi-green;
    text-decoration: underline;
    &:focus {
      outline: 0;
    }
  }
}
</style>
